/* global moment */
(function () {
  'use strict';

  angular.module('wsLrs.services').factory('DownloadDataService', ['$http', 'CardRegistry', 'Utils', function ($http, CardRegistry, Utils) {
    function downloadData(url) {
      return $http.get(url);
    }

    // Returns filename like <report-title>-yyyy-mm-dd
    function getDownloadFilename() {
      var title = CardRegistry.getCurrentCard().title || "data download";
      var fileType = Utils._try(function () {
        return CardRegistry.getCurrentCard().template.name;
      }, "") === "activity" ? "zip" : "csv";
      return "".concat(title.replace(/ /g, '_'), "-").concat(moment().format('YYYY-MM-DD'), ".").concat(fileType);
    }
    return {
      downloadData: downloadData,
      getDownloadFilename: getDownloadFilename
    };
  }]);
})();
